module.exports = __webpack_public_path__ + "static/media/logo.dcbf1bd9.png";